import Vue from 'vue';
/* eslint-disable import/no-cycle */
import Api from '@/api';
/* eslint-enable import/no-cycle */

const theState = {
    inAction: false,
    valid: false,
    portal: '',
    scope: '',
    gpNumber: '',
    ssoId: '',
    anrede: '',
    title: '',
    vorname: '',
    nachname: '',
    strasse: '',
    hausnummer: '',
    plz: '',
    ort: '',
    email: '',
    gebdat: '',
    telnr: '',
    passwort: '',
    createAnyway: false,
    existInEvalanche: false,
    existInCeleraone: false,
    redirect: false,
    scopes: ['MHN', 'NOZ'],
    allPortals: [{
        scope: 'MHN',
        color: 'success',
        value: 'SHZ',
        label: 'sh:z',
    }, {
        scope: 'MHN',
        color: 'success',
        value: 'SVZ',
        label: 'medienhaus:nord / SVZ',
    }, {
        scope: 'MHN',
        color: 'success',
        value: 'NNN',
        label: 'NNN',
    }, {
        scope: 'MHN',
        color: 'success',
        value: 'BEIG',
        label: 'A. Beig Verlag',
    }, {
        scope: 'MHN',
        color: 'success',
        value: 'PRIGNITZER',
        label: 'medienhaus:nord / Prignitzer',
    }, {
        scope: 'NOZ',
        color: 'success',
        value: 'NOZ',
        label: 'NOZ',
    }, {
        scope: 'NOZ',
        color: 'success',
        value: 'DK',
        label: 'Delmenhorster Kreisblatt',
    }],
    alert: {
        show: false,
        type: 'error',
        message: '',
    },
};

const getters = {
    portals(state) {
        return state.allPortals.filter(p => (!state.scope || state.scope === p.scope));
    },
};

const actions = {
    resetState({ commit }) {
        commit('setInAction', false);
        commit('setValid', false);
        commit('setPortal', '');
        commit('setScope', '');
        commit('setGpNumber', '');
        commit('setSsoId', '');
        commit('setAnrede', '');
        commit('setTitle', '');
        commit('setVorname', '');
        commit('setNachname', '');
        commit('setStrasse', '');
        commit('setHausnummer', '');
        commit('setPlz', '');
        commit('setOrt', '');
        commit('setEmail', '');
        commit('setGebdat', '');
        commit('setTelnr', '');
        commit('setPasswort', '');
        commit('setCreateAnyway', false);
        commit('setExistInEvalanche', false);
        commit('setExistInCeleraone', false);
        commit('setRedirect', false);
        commit('setAlert', {
            show: false,
            type: 'error',
            message: '',
        });
    },
    submit({ commit, state, dispatch }) {
        commit('setInAction', true);
        return new Promise((resolve) => {
            if (!state.existInCeleraone
                && state.existInEvalanche
                && state.createAnyway
            ) {
                dispatch('createCustomer')
                    .then(() => {
                        commit('snackbar/success', 'Benutzer erfolgreich angelegt.', { root: true });
                    }).catch(() => {
                        commit('snackbar/error', 'Beim Anlegen ist ein Fehler aufgetreten. Bitte später erneut versuchen.', { root: true });
                    }).finally(() => {
                        commit('setInAction', false);
                        resolve();
                    });
            } else {
                dispatch('validateEmail')
                    .then(() => {
                        commit('setInAction', false);
                        resolve();
                    });
            }
        });
    },

    createCustomer({ commit, state, dispatch }) {
        commit('setAlert', {
            show: false,
            type: 'error',
            message: '',
        });
        commit('setSsoId', '');
        commit('setRedirect', false);

        return new Promise((resolve, reject) => {
            Api.customer.createNewCustomer({
                portal: state.portal,
                scope: state.scope,
                gpNumber: state.gpNumber,
                anrede: state.anrede,
                title: state.title,
                vorname: state.vorname,
                nachname: state.nachname,
                strasse: state.strasse,
                hausnummer: state.hausnummer,
                plz: state.plz,
                ort: state.ort,
                email: state.email,
                gebdat: state.gebdat,
                telnr: state.telnr,
                passwort: state.passwort,
            }).then(({ data }) => {
                commit('setSsoId', data.data.user_id);
                commit('setRedirect', true);
                dispatch('transferProducts')
                    .then(() => resolve());
            }).catch(() => {
                reject();
            });
        });
    },

    validateEmail({ commit, state, dispatch }) {
        commit('setCreateAnyway', false);
        commit('setExistInEvalanche', false);
        commit('setExistInCeleraone', false);
        return new Promise((resolve) => {
            Api.customer.find(state.email)
                .then(({ data }) => {
                    if (data.celeraone) {
                        commit('setExistInCeleraone', true);
                        commit('setAlert', {
                            type: 'error',
                            message: 'Es existiert bereits ein Benutzer mit dieser Email.',
                            show: true,
                        });
                        resolve();
                    } else if (data.evalanche) {
                        commit('setExistInEvalanche', true);
                        commit('setAlert', {
                            type: 'warning',
                            message: 'Dieser Nutzer existiert bereits in Evalanche.',
                            show: true,
                        });
                        resolve();
                    } else {
                        dispatch('createCustomer')
                            .then(() => {
                                commit('snackbar/success', 'Benutzer erfolgreich angelegt.', { root: true });
                            }).catch(() => {
                                commit('snackbar/error', 'Beim Anlegen ist ein Fehler aufgetreten. Bitte später erneut versuchen.', { root: true });
                            }).finally(() => {
                                resolve();
                            });
                    }
                })
                .catch(() => {
                    commit('setAlert', {
                        type: 'error',
                        message: 'Die angegebene Email darf nicht verwendet werden.',
                        show: true,
                    });
                    resolve();
                });
        });
    },

    transferProducts({ state, commit }) {
        return new Promise((resolve) => {
            if (!!state.scope && !!state.gpNumber) {
                commit('snackbar/info', 'Produkte werden jetzt übertragen.', { root: true });
                Api.customer
                    .linkUserToOrder(state.ssoId, state.gpNumber, state.scope, false)
                    .then(() => {
                        commit('snackbar/success', 'Produkte erfolgreich übertragen.', { root: true });
                    }).catch(() => null) // {
                    // Fehlermeldung deaktiviert, bis MSP-API keine Timeouts mehr liefert
                    // commit('snackbar/error', 'Produktübertragung fehlgeschlagen.', { root: true });
                    // });
                    .finally(() => resolve());
            } else {
                resolve();
            }
        });
    },
};

const mutations = {
    setInAction(state, payload) {
        state.inAction = payload;
    },

    setValid(state, payload) {
        state.valid = payload;
    },

    setPortal(state, payload) {
        state.portal = payload;
    },

    setScope(state, payload) {
        state.scope = payload;
        const mhnPortale = state.allPortals.filter(p => p.scope === 'MHN').map(p => p.value);
        if (payload === 'MHN' && mhnPortale.indexOf(state.portal) < 0) {
            state.portal = '';
        } else if (payload === 'NOZ') {
            state.portal = 'NOZ';
        }
    },

    setGpNumber(state, payload) {
        state.gpNumber = payload;
    },

    setSsoId(state, payload) {
        state.ssoId = payload;
    },

    setAnrede(state, payload) {
        state.anrede = payload;
    },

    setTitle(state, payload) {
        state.title = payload;
    },

    setVorname(state, payload) {
        state.vorname = payload;
    },

    setNachname(state, payload) {
        state.nachname = payload;
    },

    setStrasse(state, payload) {
        state.strasse = payload;
    },

    setHausnummer(state, payload) {
        state.hausnummer = payload;
    },

    setPlz(state, payload) {
        state.plz = payload;
    },

    setOrt(state, payload) {
        state.ort = payload;
    },

    setEmail(state, payload) {
        state.email = payload;
    },

    setGebdat(state, payload) {
        state.gebdat = payload;
    },

    setTelnr(state, payload) {
        state.telnr = payload;
    },

    setPasswort(state, payload) {
        state.passwort = payload;
    },

    setCreateAnyway(state, payload) {
        state.createAnyway = payload;
    },

    setExistInEvalanche(state, payload) {
        state.existInEvalanche = payload;
    },

    setExistInCeleraone(state, payload) {
        state.existInCeleraone = payload;
    },

    setRedirect(state, payload) {
        state.redirect = payload;
    },

    setAlert(state, payload) {
        Vue.set(state, 'alert', payload);
    },

};

export default {
    namespaced: true,
    state: theState,
    getters,
    actions,
    mutations,
};
